/** Which side of the authentication exchange this handler represents. */
export enum AuthenticationDirection {
  Initiator = 0,
  Responder = 1,
}
